export const USHER_WAITING = 'usherWaiting'
export const USHER_LOOKING = 'usherLooking'
